import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { usePartnerBilling } from "../PartnerBillingContext";
import { normalizePartnerProfileType } from "../partnerProfileConfig";

/**
 * Terminologia e rótulos do portal conforme perfil do representante.
 */
export function usePartnerTerminology() {
  const { t } = useTranslation("app");
  const { profile, reseller } = usePartnerBilling();
  const profileType = normalizePartnerProfileType(profile?.type || reseller?.profile_type);

  return useMemo(() => {
    const badge = t(`partnerProfiles.${profileType}.badge`, {
      defaultValue: t("platformPage.partnerConsoleBadge", { defaultValue: "Representante" }),
    });
    const entitySingular = t(`partnerProfiles.${profileType}.entitySingular`, {
      defaultValue: t("partnerProfiles.generic.entitySingular", { defaultValue: "workspace" }),
    });
    const entityPlural = t(`partnerProfiles.${profileType}.entityPlural`, {
      defaultValue: t("partnerProfiles.generic.entityPlural", { defaultValue: "workspaces" }),
    });
    const navWorkspaces = t(`partnerProfiles.${profileType}.navWorkspaces`, {
      defaultValue: entityPlural.charAt(0).toUpperCase() + entityPlural.slice(1),
    });
    const overviewHeading = t(`partnerProfiles.${profileType}.overviewHeading`, {
      defaultValue: t("partnerConsole.overview.heading", { defaultValue: "Panorama do representante" }),
    });
    const overviewIntro = t(`partnerProfiles.${profileType}.overviewIntro`, {
      defaultValue: t("partnerConsole.overview.intro"),
    });
    const consoleSubtitle = t(`partnerProfiles.${profileType}.consoleSubtitle`, {
      name: reseller?.name || "",
      defaultValue: reseller?.name
        ? t("platformPage.partnerConsoleSubtitleWithName", { name: reseller.name })
        : t("platformPage.partnerConsoleSubtitle"),
    });

    return {
      profileType,
      badge,
      entitySingular,
      entityPlural,
      navWorkspaces,
      overviewHeading,
      overviewIntro,
      consoleSubtitle,
    };
  }, [profileType, reseller?.name, t]);
}
